const fmt = (n, d = 1) => new Intl.NumberFormat("tr-TR", { maximumFractionDigits: d }).format(Number(n) || 0);
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export function printNutritionLabel(r) {
  const name = esc(r.display_name || r.product_name);
  const w = Number(r.total_weight) || 0;
  const per100 = (v) => (w > 0 ? (v / w) * 100 : 0);
  const row = (label, v, unit, bold = false) => `
    <tr class="${bold ? "b" : ""}"><td>${label}</td><td>${fmt(v)}${unit}</td><td>${fmt(per100(v))}${unit}</td></tr>`;
  const html = `<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>${name} — Besin Etiketi</title>
  <style>
    @page { size: 80mm auto; margin: 6mm; }
    body { font-family: Helvetica, Arial, sans-serif; color:#111; width:72mm; margin:0 auto; }
    .brand { font-size:10px; letter-spacing:3px; text-transform:uppercase; color:#555; }
    h1 { font-size:20px; margin:2px 0 0; }
    .cat { font-size:11px; color:#555; margin-bottom:8px; }
    .kcal { display:flex; justify-content:space-between; align-items:baseline; border-top:8px solid #111; border-bottom:4px solid #111; padding:6px 0; }
    .kcal b { font-size:28px; } .kcal span { font-size:11px; }
    table { width:100%; border-collapse:collapse; font-size:12px; }
    th { text-align:right; font-size:10px; color:#555; padding:4px 0; border-bottom:1px solid #111; }
    th:first-child { text-align:left; }
    td { padding:4px 0; border-bottom:1px solid #ddd; text-align:right; } td:first-child { text-align:left; }
    tr.b td { font-weight:700; }
    .vp { margin-top:8px; border:2px solid #111; border-radius:6px; padding:6px 8px; display:flex; justify-content:space-between; font-weight:700; }
    .ing { font-size:10px; color:#333; margin-top:8px; line-height:1.4; }
    .foot { font-size:9px; color:#777; margin-top:10px; text-align:center; }
    .btn { position:fixed; top:8px; right:8px; padding:8px 14px; background:#111; color:#fff; border:0; border-radius:6px; cursor:pointer; }
    @media print { .btn { display:none; } }
  </style></head><body>
  <button class="btn" onclick="window.print()">Yazdır</button>
  <div style="display:flex;align-items:center;gap:8px"><img src="${window.location.origin}/logo.png" alt="" style="width:48px;height:48px;object-fit:contain"><div class="brand">FIT HOUSE<br><span style="letter-spacing:1px">Drinks &amp; Coffee</span></div></div>
  <h1>${name}</h1>
  <div class="cat">${esc(r.category)} · Porsiyon ${fmt(w, 0)} g</div>
  <div class="kcal"><span>Enerji</span><b>${fmt(r.total_calories, 0)} kcal</b></div>
  <table>
    <tr><th>Besin Değeri</th><th>Porsiyon</th><th>100 g</th></tr>
    ${row("Protein", r.total_protein, " g", true)}
    ${row("Karbonhidrat", r.total_carbs, " g")}
    ${row("Yağ", r.total_fat, " g")}
    ${row("Lif", r.total_fiber || 0, " g")}
  </table>
  <div class="vp"><span>Volume Puan (VP)</span><span>${fmt(r.total_vp)}</span></div>
  <div class="ing"><b>İçindekiler:</b> ${r.ingredients.map((i) => `${esc(i.name)} (${i.unit === "adet" ? `${fmt(i.grams, 1)} adet` : `${i.mode === "adet" && i.quantity ? `${fmt(i.quantity, 1)} adet · ` : ""}${fmt(i.grams, 0)} ${i.unit || "g"}`})`).join(", ")}</div>
  <div class="foot">Değerler reçeteye göre hesaplanmıştır · fithouse</div>
  <script>window.onload=function(){setTimeout(function(){window.print()},300)}</script>
  </body></html>`;
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  const win = window.open(url, "_blank", "width=420,height=720");
  if (!win) { URL.revokeObjectURL(url); return false; }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}
